import React from 'react';
function Route(_ref) {
  let {
    color = '#335B70',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 10.052a2.34 2.34 0 002.338-2.338A2.34 2.34 0 0012 5.377a2.34 2.34 0 00-2.338 2.337A2.34 2.34 0 0012 10.052zM12 2c3.15 0 5.714 2.525 5.714 5.628 0 3.353-4.631 11.515-5.714 11.515-1.083 0-5.714-8.162-5.714-11.515C6.286 4.525 8.849 2 12 2zm9.836 19.581a.952.952 0 01-.788.419H2.952a.952.952 0 01-.884-1.306l1.905-4.762a.953.953 0 01.884-.599h2.095a.952.952 0 010 1.905h-1.45l-1.143 2.857h15.282l-1.143-2.857h-1.45a.952.952 0 010-1.905h2.095c.389 0 .74.237.884.599l1.905 4.762a.952.952 0 01-.096.887",
    fill: color,
    fillRule: "evenodd"
  }));
}
export default Route;